
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/a38081f59d06715bada160c416df5b40.jpg"
          alt="RetroFlavor"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 text-center">
        <img 
          src="https://static.readdy.ai/image/e054c862bb8832d032cf0cf58507f2c7/c2b142d97304902a971209e1dcb8c95b.png"
          alt="RetroFlavor DF"
          className="h-48 mx-auto mb-6 drop-shadow-2xl"
        />
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-2xl mx-auto font-light">
          Sabores artesanais que aquecem o coração
        </p>
        <a
          href="#produtos"
          className="inline-block bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-full text-lg font-medium transition-all duration-300 hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
        >
          Ver Produtos
        </a>
      </div>
    </section>
  );
}
